import { apiSlice } from '@/store/api/apiSlice';

interface PlanetNakshatraChange {
  nakshatra: string;
  timestamp: string;
}

export interface PlanetNakshatraGocharResponse {
  planetName: string;
  nakshtra: PlanetNakshatraChange[];
}

export const planetNakshatraTransitApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlanetNakshatraTransit: builder.query<PlanetNakshatraGocharResponse[], void>({
      query: () => ({
        url: '/transits/planet-transit',
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetPlanetNakshatraTransitQuery } = planetNakshatraTransitApi;
